export default function toastContainer() {
    return {
        get items() {
            return this.$store.toasts.items;
        },

        dismiss(id) {
            this.$store.toasts.remove(id);
        },

        typeClass(type) {
            const map = {
                success: 'border-green-200 bg-green-50 text-green-900 dark:border-green-800 dark:bg-green-950 dark:text-green-100',
                error: 'border-red-200 bg-red-50 text-red-900 dark:border-red-800 dark:bg-red-950 dark:text-red-100',
                warning: 'border-yellow-200 bg-yellow-50 text-yellow-900 dark:border-yellow-800 dark:bg-yellow-950 dark:text-yellow-100',
                info: 'border-border bg-background text-foreground',
            };
            return map[type] || map.info;
        },
    };
}
